import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import RecipeView from '../views/RecipeView.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/kategori/:category',
    name: 'Category',
    component: HomeView
  },
  {
    path: '/recept/:id',
    name: 'Recipe',
    component: RecipeView
  },
  // Omdirigera eventuella gamla/felaktiga sökvägar till startsidan
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { top: 0, behavior: 'smooth' }
  }
})

// Bakåtkompatibilitet för gamla hash-länkar (t.ex. /#basta-pannkaksreceptet eller /#kategori-pannkakor)
router.beforeEach((to, from, next) => {
  if (to.hash) {
    const rawHash = to.hash.replace(/^#/, '')
    if (rawHash.startsWith('kategori-')) {
      const cat = rawHash.replace('kategori-', '')
      return next({ path: `/kategori/${cat}` })
    }
    if (rawHash) {
      return next({ path: `/recept/${rawHash}` })
    }
  }
  next()
})

export default router
